import React, { createContext } from 'react';
import processing, { Processing } from '@/school-management/utils/processing';

export const ProcessingContext = createContext<Processing | null>(null);

export const ProcessingProvider = ({ children }: { children: React.ReactNode }) => {
  return <ProcessingContext.Provider value={processing}>{children}</ProcessingContext.Provider>;
};
